export const generateUsersOptions = (): uui.domain.ui.list.ListOptions => {
  return {
    search: {
      query: '',
      fields: ['fullName'],
      operator: 'or',
      exactMatch: false,
    },
    filter: [],
    sort: [
      {
        field: 'name',
        direction: 'asc',
      },
    ],
    group: [],
  }
}
